const backOrders = {
  title: "Backorders",
  backOrderList: {
    orderDate: "Order date",
    orderNumber: "Order number",
    shipTo: "Ship to",
  },
  backOrderItem: {
    itemCode: "Item code",
    items: "Items",
    mobileSingleItem: "item",
    mobileMultipleItems: "items",
    estimatedDate: "Estimated date",
    mobileEstimatedDate: "Estimated date to",
    unKnownEstimatedDate: "Unknown",
    viewSimilarProducts: "View similar products",
    cancelItem: "Cancel item",
    cancelRequested: "Cancel requested",
  },
  emptyBackOrder: "You don't have any items on backorder.",
  loadMore: "Load more",
};

export { backOrders };
